import React from 'react';
import { BalanceSheetStandard } from './balanceSheetStandard';
import { BalanceSheetDetailed } from './balanceSheetDetailed';

/**
 * BalanceSheet component that renders different templates based on invoiceTemplate
 * 
 * Invoice Template Versions:
 * - Standard (default): Simple balance without detailed categories
 * - Detailed (id: '2'): Full balance with all categories and subcategories
 * 
 * The template is determined by dataBilling.balance.invoiceTemplate.id
 * If invoiceTemplate is not present or id !== '2', Standard template is rendered
 */
export const BalanceSheet = ({ dataBilling }) => {
  const balance = dataBilling?.balance;
  const invoiceTemplate = balance?.invoiceTemplate;
  
  // Determine which version to render
  // Default to Standard unless invoiceTemplate.id === '2' (Detailed)
  const isDetailed = invoiceTemplate?.id === '2';

  return isDetailed ? (
    <BalanceSheetDetailed dataBilling={dataBilling} />
  ) : (
    <BalanceSheetStandard dataBilling={dataBilling} />
  );
};
